import { inject, Injectable } from '@angular/core';
import { SecondaryNavActionEvent } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderStateService } from './header-state.service';
import { ScreenDetectionService } from './screen-detection.service';

@Injectable({ providedIn: 'root' })
export class SecondaryNavigationService {
  private headerState = inject(HeaderStateService);
  private screenDetectionService = inject(ScreenDetectionService);

  handleSecondaryNavAction(event: SecondaryNavActionEvent): void {
    if (event.id) {
      this.headerState.selectedNav.set(event.id);
      this.headerState.secondaryNav = event.secondaryId;
    }
  }

  getNavValue(
    eventId: string,
    previousPrimarySelectedNav: string,
    selectedPrimaryNav: string,
    isDarkSiteLevel: boolean
  ): string {
    if (this.screenDetectionService.isMobile()) return eventId;
    if (
      this.shouldClearNav(
        previousPrimarySelectedNav,
        eventId,
        selectedPrimaryNav,
        isDarkSiteLevel
      )
    )
      return '';
    return eventId;
  }

  private shouldClearNav(
    previousNav: string,
    eventId: string,
    selectedNav: string,
    isDarkSiteLevel: boolean
  ): boolean {
    return previousNav === eventId && selectedNav !== '' && isDarkSiteLevel;
  }
}
